import { cn } from '@/lib/utils'
import { openCalendly } from '@/lib/calendly'
import { buttonVariants } from '@/components/ui/button'
import type { VariantProps } from 'class-variance-authority'

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> &
  VariantProps<typeof buttonVariants>

export function CalendlyBtn({ className, variant, size, children, ...props }: Props) {
  return (
    <button
      onClick={openCalendly}
      className={cn(buttonVariants({ variant, size }), 'cursor-pointer', className)}
      {...props}
    >
      {children}
    </button>
  )
}
